import {ValidationResult} from 'module/CustomField/type/CFComponentType'
import {CustomFieldTO} from 'generated/JavaTO'
import _ from 'lodash'
import {FieldError} from 'module/CustomField/type/FieldError'

export function filterCFErrors(validationResult: ValidationResult, cfDef: CustomFieldTO, pos?: number) {
	if (!validationResult) return []
	const hasPos = typeof pos === 'number'
	return _.uniq(
		[...(validationResult[cfDef.id] || []), ...(validationResult[cfDef.dstField] || [])]
			.filter(x => !hasPos || x.pos == null || x.pos === pos)
			.map((x) => x.message),
	)
}

export function filterCFErrorsGlobal(validationResult: ValidationResult, cfDefs: CustomFieldTO[]): FieldError[] {
	if (!validationResult || !cfDefs || !cfDefs.length) return []
	let errorKeysShowInForm: string[] = cfDefs.flatMap(cfDef => cfDef.visible ? [cfDef.id + '', cfDef.dstField] : [])
	return Object.entries(validationResult)
		.flatMap(([key, err]) => !key || key === 'null' || key === 'undefined' || !errorKeysShowInForm.includes(key) ? err : [])
}